<template>
    <label :for="id" class="flex justify-start cursor-pointer">
      <div class="flex flex-col items-center justify-center">
        <input
          :value="id"
          type="checkbox"
          class="mt-1 h-4 w-4 form-checkbox rounded text-signablePrimary1 justify border-solid border-1 border-disabledGrey"
          @input="onInputChange"
          :checked="value"
        >
      </div>
      <div v-if="label" class="ml-2">
        <p>{{label}}</p>
      </div>
    </label>
</template>
<script>
export default {
  name: 'CheckboxInput',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  methods: {
    onInputChange($event) {
      this.$emit('input', $event.target.checked);
      this.$emit('change', $event.target.checked);
    },
  },
};
</script>
